import { render, staticRenderFns } from "./AgendaItemListItem.vue?vue&type=template&id=de443a9e"
import script from "./AgendaItemListItem.vue?vue&type=script&lang=js"
export * from "./AgendaItemListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports